/** Routes artefact preview to the correct inline renderer (LOA, cheat sheet, advice deck, advisor notes). */

import {
  isDocumentTextReviewArtefact,
  isCheatSheetReviewArtefact,
  isReportDeckReviewArtefact,
} from "./artefactKind";
import type { ArtefactReviewItem } from "./types";
import { AdviceDeckArtefactPreview } from "./AdviceDeckArtefactPreview";
import { AdvisorNotesArtefactPreview } from "./AdvisorNotesArtefactPreview";
import { CheatSheetArtefactPreview } from "./CheatSheetArtefactPreview";
import { LoaArtefactPreview } from "./LoaArtefactPreview";

interface ArtefactPreviewProps {
  artefact: ArtefactReviewItem;
  className?: string;
  /** Run catalogue key — process-plan runs always review cheat sheets. */
  catalogueKey?: string | null;
}

export function ArtefactPreview({ artefact, className, catalogueKey }: ArtefactPreviewProps) {
  if (isDocumentTextReviewArtefact(artefact)) {
    return <AdvisorNotesArtefactPreview artefact={artefact} className={className} />;
  }
  if (isReportDeckReviewArtefact(artefact)) {
    return <AdviceDeckArtefactPreview artefact={artefact} className={className} />;
  }
  if (isCheatSheetReviewArtefact(artefact, catalogueKey)) {
    return <CheatSheetArtefactPreview artefact={artefact} className={className} />;
  }
  return <LoaArtefactPreview artefact={artefact} className={className} />;
}
